export default {
  ALIGN: 'icon/ALIGN',
  ALIGN_CENTER: 'icon/ALIGN_CENTER',
  ALIGN_MIDDLE: 'icon/ALIGN_MIDDLE',
  ALIGN_TOP: 'icon/ALIGN_TOP',
  ALIGN_BOTTOM: 'icon/ALIGN_BOTTOM',
  ALIGN_LEFT: 'icon/ALIGN_LEFT',
  ALIGN_RIGHT: 'icon/ALIGN_RIGHT',
  BACKWARD: 'icon/BACKWARD',
  BACKWARD_STEP: 'icon/BACKWARD_STEP',
  CENTER: 'icon/CENTER',
  CHANGE_COLOR: 'icon/CHANGE_COLOR',
  CHANGE_PLACEMENT: 'icon/CHANGE_PLACEMENT',
  COPY: 'icon/COPY',
  CROP: 'icon/CROP',
  CUT: 'icon/CUT',
  DISTRIBUTE_HORIZONTAL: 'icon/DISTRIBUTE_HORIZONTAL',
  DISTRIBUTE_VERTICAL: 'icon/DISTRIBUTE_VERTICAL',
  DUPLICATE: 'icon/DUPLICATE',
  FORWARD: 'icon/FORWARD',
  FORWARD_STEP: 'icon/FORWARD_STEP',
  MOVE: 'icon/MOVE',
  PASTE: 'icon/PASTE',
  REMOVE: 'icon/REMOVE',
  RESET_CLIPART_COLORS: 'icon/RESET_CLIPART_COLORS',
  RESIZE: 'icon/RESIZE',
  RESTORE: 'icon/RESTORE',
  ORDER_RECENT_UPLOADS: 'icon/ORDER_RECENT_UPLOADS',
  ROTATE: 'icon/ROTATE',
  SET_VIEW: 'icon/SET_VIEW',
  UPDATE_HORIZONTAL_FLIP: 'icon/UPDATE_HORIZONTAL_FLIP',
  UPDATE_VERTICAL_FLIP: 'icon/UPDATE_VERTICAL_FLIP',
  UPDATE_SINGLE_COLOR: 'icon/UPDATE_SINGLE_COLOR',
  UPDATE_SINGLE_COLOR_AND_CONTRAST: 'icon/UPDATE_SINGLE_COLOR_AND_CONTRAST',
  UPDATE_CONTRAST: 'icon/UPDATE_CONTRAST',
  UPDATE_INVERT_CONTRAST: 'icon/UPDATE_INVERT_CONTRAST',
  UPDATE_POSITION: 'icon/UPDATE_POSITION',
  TOGGLE_INVERTED_CLIPART: 'icon/TOGGLE_INVERTED_CLIPART'
};
